import { ofType } from "redux-observable";
import { map } from "rxjs/operators";
import { utilSmsOffers } from "../../../../utils/utilSmsOffers";
import { TypeActionShop } from "../../../shop/actionShop";
import { actionGameTrackingUpdateShop } from "../../actionGameTracking";
import { IdGameTrackingShopState } from "../IdGameTrackingShopState";
export var epicGameTrackingShopCheckout = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionShop.RequestPurchase), map(function (action) {
        var purchaseOfferNameId = action.offer.purchaseOfferNameId;
        var isSmsOffer = purchaseOfferNameId === utilSmsOffers.getSmsOffersPurchaseOfferNameId();
        var offerId = isSmsOffer
            ? "smsPackagePOs" + action.offer.offerCharacteristicId.toString()
            : action.offer.purchaseOfferNameId;
        return actionGameTrackingUpdateShop(IdGameTrackingShopState.CHECKOUT, offerId);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/game-tracking/shop/epics/epicGameTrackingShopCheckout.ts
// module id = 1877
// module chunks = 3